import styled from 'styled-components';
import tw from 'tailwind.macro';
import { CellStyle } from './common';
import { getDayOfTheWeek } from './utils';

const CalendarHeaderCell = styled.span`
  ${CellStyle}
  ${tw`text-p-small leading-p-small items-center`}
  height: min-content;
  font-weight: normal;
`;

const CalendarHeaderContainer = styled.thead`
  ${tw`bg-white`}

  & th:first-child {
    ${tw`rounded-tl-15 rounded-bl-15`}
  }

  & th:last-child {
    ${tw`rounded-tr-15 rounded-br-15`}
  }
`;

const PriceCalendarHeader = () => {
  const dayOfTheWeek = getDayOfTheWeek();

  return (
    <CalendarHeaderContainer>
      <tr>
        {dayOfTheWeek.map((day) => (
          <th key={day}>
            <CalendarHeaderCell>{day}</CalendarHeaderCell>
          </th>
        ))}
      </tr>
    </CalendarHeaderContainer>
  );
};

export default PriceCalendarHeader;
